import { render, staticRenderFns } from "./Journaling.vue?vue&type=template&id=0643cd8e&scoped=true"
import script from "./Journaling.vue?vue&type=script&lang=js"
export * from "./Journaling.vue?vue&type=script&lang=js"
import style0 from "./Journaling.vue?vue&type=style&index=0&id=0643cd8e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0643cd8e",
  null
  
)

export default component.exports